import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {ProviderAccount} from '../../models/ProviderAccount';

@Injectable({
  providedIn: 'root'
})
export class ProviderAccountService {

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Sem `channel` a chamada é a de sempre (o backend responde as de SMS, que é o
   * default dele). Com `channel`, só as contas daquele canal: a rota RCS não
   * pode oferecer conta de SMS, e vice-versa.
   */
  listAll(channel?: 'sms' | 'rcs'): Observable<ProviderAccount[]> {
    const params = channel ? new HttpParams().set('channel', channel) : undefined;

    return this.http.get<ProviderAccount[]>(`${environment.apiUrl}/provider-accounts`, { params });
  }
}
